import React from 'react';
import cn from 'classnames';
import styles from './CircleSkeleton.module.scss';
const CircleSkeleton = ({ className }) => (React.createElement("div", { className: cn(className, styles.container) }));
export default CircleSkeleton;
//# sourceMappingURL=CircleSkeleton.js.map